<template>
<div>
  <Header :esSearch='keywords'/>
  <Navigationzj/>
  <div class="hxq_subpage">
    <div class="hxq_ppsp">
      <div class="hxq_fllb_sx">
        <div class="hxq_fllb_sx_yx">
          <!-- <a href="javascript: void(0);" data-sx="close">收起筛选</a> -->
          <!-- <a href="/News/xwzx.html"
              style="display: inline-block;width: 175px;margin-right: 30px;background: none;border:none;text-align:left;">常见问题，产品知识：相关文章</a> -->
          <div class="hxq_yzjk_mbx">
            <a href="/" class="allResult">首页<span class="newspan">></span></a>
            以下是为您找到与<span style="width: auto;color: blue;font-size: 13px;">"{{keywords}}"</span>相关的结果
          </div>
          <div class="clearfix">
            <el-tag
              v-for="(item,index) in selectName" :key="index"
              closable
              :disable-transitions="false"
              type="danger"
              @close="handleClose(index)">
              {{item.param_name}}: {{item.name}}
            </el-tag>
          </div>
        </div>
        <div class="hxq_fllb_sx_tj" :style="AttrStyle" v-loading="atterloading">
          <div class="hxq_fllb_sx_tj1" v-if="searchCate.length && searchCateType" :style="cateType?'height:auto;border: 1px solid #e9e9e9;':'height:34px;overflow: hidden;border: 1px solid #e9e9e9;'">
            <em>分类：</em>
            <div style="width:950px;">
              <a href="javascript:void(0);" class="on">全部</a>
              <template v-for="(item,index) in searchCate">
                <a href="javascript:void(0);" :key="index" @click="checkCate(index)">{{ item.title }}</a>
              </template>
            </div>
            <span @click="changeCate">{{cateType?'收起':'展开'}}</span>
          </div>
          <div class="hxq_fllb_sx_tj1" v-if="brandList.length && !brandType">
            <em>品牌：</em>
            <div>
              <a href="javascript:void(0);" class="on">全部</a>
              <template v-for="(item,index) in brandList">
                <a href="javascript:void(0);" :key="index" @click="checkBrand(index)">{{ item.name }}</a>
              </template>
            </div>
            <!-- <span>更多</span> -->
          </div>
          <template v-for="(item,index) in Attribute.slice(0,u)">
            <div class="hxq_fllb_sx_tj1" :key="index" v-if="!item.isSelect" :style="item.open?'height:auto':'height:34px;overflow: hidden;'">
              <em>{{ item.name }}：</em>
              <div :ref="'he'+index">
                <a href="javascript:;" class="on">全部</a>
                <a href="javascript:;" v-for="(value,i) in item.option_values" :key="i" @click="checkAttribute(i,index)">{{ value.name }}</a>
              </div>
              <span v-show="item.showMore" @click="changeOpen(index)" :data="getHeight(('he'+index), index)">{{item.open?'收起':'展开'}}</span>
            </div>
          </template>
          <div v-if="Attribute.length > 2" class="showMoreAttr" @click="changeAttrOpen()">
            <span v-if="AttrOpen" class="showmore-text">收起<i class='up-arrow'></i></span>
            <span v-else class="showmore-text">更多参数（{{ Attribute[2].name }}<span v-if="Attribute[3]">/{{ Attribute[3].name }}...</span>）<i></i></span>
          </div>
        </div>
        <div class="hxq_fllb_sx_tj" style="margin-top:10px" v-if="lookingSearch.length > 1">
          <div class="hxq_fllb_sx_tj2">
            <em>你是不是想找：</em>
            <div>
              <a href="javascript:void(0);" v-for="(item,index) in lookingSearch.slice(0,10)" :key="index" @click="searchKwywords(item.suggestion)">{{ item.suggestion }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="hxq_yzjk_px">
        <!-- <div class="hxq_yzjk_px_lt">
          <a href="javascript:;" style="width: 149px;" paixu="">综合排序</a>
          <a href="javascript:;" style="width: 149px;" pricepx="" paixu="pricepx">价格
          ↑↓
          </a>
          <a  href="javascript:;" style="width: 149px;" xlpx="" paixu="xlpx">销量
          ↓
          </a>
        </div> -->
        <div class="hxq_yzjk_right1">
          <div class="hxq_yzjk_right1_one">
            <span class="pricelass" :class="{on:listQuery.myprice}" style="width:100px" v-if="current_user && current_user.id && current_user.company_id != 1 && cid"><a href="javascript:;"  @click="screen()">协议产品</a></span>
            <span class="bigtut" :class="{on:listMode=='card'}"><a href="javascript:;" @click="listMode='card'">大图</a></span>
            <span class="smalltut" :class="{on:listMode=='list'}"><a href="javascript:;"  @click="listMode='list'">列表</a></span>
          </div>
          <div class="hxq_yzjk_right1_two">
            共 <em class="red">{{ listQuery.estotal }}</em> 件商品
            <!-- <em class="red">345435</em> / 56456 -->
          </div>
          <a class="hxq_yzjk_right1_four " href="javascript:;" @click="batchAddCart()">
            加入购物车
          </a>
        </div>
      </div>
      <div class="hxq_ppsp_box" v-if="listMode=='card'" v-loading="qyloading">
        <ul class="hxq_ppsp_ul clearfix">
          <li v-for="(item,index) in list" :key="index" class="this_page_css" style="position:relative;">
            <img class="agreement" src="../../assets/images/xy11.png" v-if="item.pid && current_user.id && current_user.company_id != 1">
            <a href='javascript:;' @click="toSearchDetail(item.id)" :title="item.title">
              <img v-real-img="item.imgpath" src="../../assets/images/zwtp.jpg" :alt="item.title" width="220" height="220">
            </a>
            <h3>
              <router-link :to="{path:'/GoodsDetail',query:{id:item.id}}" class="this_page_title" target="_blank" :title="item.title" v-html="item.estitle"></router-link>
            </h3>
            <div class="hxq_ppsp_ul_jg">
              <em>
                <span v-if="item.tax_price && item.tax_price > 0">￥</span><span v-if="item.tax_price && item.tax_price > 0" style="font-weight:bold;">{{ item.tax_price }}</span>
                <span v-else style="font-weight:bold">询价</span>
                <i style="display: block;width: 67px;height: 25px;background: #fe722c;text-align: center;font-size: 12px;line-height: 25px;color: #fff;border-radius: 4px;float:right;" v-if="item.delivery_time">
                  {{ item.delivery_time }}日出货
                </i>
                <i style="display: block;width: 67px;height: 25px;background: #fe722c;text-align: center;font-size: 12px;line-height: 25px;color: #fff;border-radius: 4px;float:right;" v-else>
                  当日出货
                </i>
              </em>
            </div>
            <div class="hxq_ppsp_ul_join clearfix">
              <div class="hxq_ppsp_ul_join_l" style="height: 40px;">
                <p>订货号：{{ item.sku}}</p>
                <p>销量：<count-to :start-val="0" :end-val="parseInt(item.sales)" :duration="2600" class="card-panel-num"/></p>
              </div>
            </div>
            <div class="hxq_ppsp_ul_join clearfix">
              <div class="hs-collect" style="height: 32px;line-height: 32px;">
                <el-button v-if="item.isCollect" type="warning" :autofocus="true" size="small" icon="el-icon-star-on" style="float:left;" @click="collect(item)">已收藏</el-button>
                <el-button v-else type="warning" :autofocus="true" size="small" icon="el-icon-star-off" style="float:left;" @click="collect(item)">收藏</el-button>
                <el-button type="primary" plain size="small" icon="el-icon-shopping-cart-full" style="float:right;" @click="addCart(item)">加入购物车</el-button>
              </div>
            </div>
            <!-- <div class="hxq_ppsp_ul_join clearfix">
              <div style="height: 33px;"></div>
            </div> -->
          </li>
        </ul>
        <div v-show="emptyShow" class="cght_cnxhtiwtjsp">
          <div>
            <em class="myemptydata">暂无数据</em>
          </div>
        </div>
      </div>
      <div class="hxq_ppsp_box" v-if="listMode=='list'">
        <div class="fllbsmall_con">
          <div class="fllbsmall_con_tit clearfix">
            <div style="width: 294px;"><span>商品信息</span></div>
            <div style="width: 133px;">品牌</div>
            <div style="width: 342px;">规格</div>
            <div style="width: 139px;">志鹏价</div>
            <div class="w140">预计出货日</div>
            <div class="w145" style="width: 150px;">购买数量</div>
          </div>
          <div class="fllbsmall_con_bottom">
            <ul>
              <li class="clearfix this_page_li"  v-for="(item,index) in list" :key="index">
                <div class="fllbsmall_con_bottom_1 clearfix" style="width: 294px;">
                  <router-link class="fllbsmall_con_bottom_1l" :to="{path:'/GoodsDetail',query:{id:item.id}}" target="_blank" :title="item.title">
                    <img v-real-img="item.imgpath" src="../../assets/images/zwtp.jpg" width="76" height="76">
                  </router-link>
                  <div class="fllbsmall_con_bottom_1r" :class="{'agreement_list':item.pid && current_user.id && current_user.company_id != 1}">
                    <h3><router-link :to="{path:'/GoodsDetail',query:{id:item.id}}" target="_blank" :title="item.title" v-html="item.estitle"></router-link></h3>
                    <span>订货号：{{ item.sku }}</span>
                  </div>
                </div>
                <div class="m33" style="width: 133px;">{{item.brand_title}}</div>
                <div style="width: 342px;text-align:left;height:80px">
                  <el-tag size="mini" style="margin-left:10px;margin-top:6px;" v-for="(sp,index) in item.specParamList" :key="index">{{sp.param_name}}：{{sp.option_value}}</el-tag>
                </div>
                <div class="m33 red" style="width: 139px;font-weight:bold;" v-if="item.tax_price && item.tax_price > 0">￥{{ item.tax_price}}</div>
                <div class="m33 red" style="width: 139px;" v-else>询价</div>
                <!--<div class="w133 red m33">￥{$vo.marketprice}</div>-->
                <div class="w140 list_surekc" style="margin-top:18px;">
                  <em v-if="item.delivery_time">
                    <span>{{ item.delivery_time }}日出货</span>
                  </em>
                  <em v-else>
                    <em>有库存</em>
                    <span>当日出货</span>
                  </em>
                </div>
                <div class="list_sureinput" style="margin-top:16px;width:130px;">
                  <el-input-number v-model="item.number" @change="handleChange(item)" :min="item.limits"  size="small"></el-input-number>
                  <div class="list_sureinput_b">
                    {{ item.units }}
                  </div>
                </div>
              </li>
            </ul>
            <div v-show="emptyShow" class="cght_cnxhtiwtjsp">
              <div>
                <em class="myemptydata">暂无数据</em>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pagination v-show="listQuery.estotal>0" :total="listQuery.estotal" :page.sync="listQuery.espage" :limit.sync="listQuery.limit" @pagination="getsearch" />
  </div>
  <Bottom/>
</div>
</template>
<script>
import cate from '@/api/createGroy'
import api from '@/api/goods'
import search from '@/api/search'
import service from '@/api/service'
// import vuelist from '@/utils/vue_list'
import Pagination from '@/components/Pagination'
import Header from '@/components/Header'
import Navigationzj from '@/components/Navigationzj'
import Bottom from '@/components/Member/Bottom'
import CountTo from 'vue-count-to'
import { mapGetters } from 'vuex'

export default {
  // mixins: [vuelist],
  inject: ['reload'], // 注入依赖 实现页面刷新
  components: { Pagination, Navigationzj, Header, Bottom, CountTo },
  data () {
    return {
      api,
      cid: '',
      keywords: this.$route.query.keywords,
      searchType: this.$route.query.searchType,
      qyloading: false,
      atterloading: false,
      searchCateType: true, // true显示分类；FALSE不显示
      searchCate: [], // 搜索包含关键词产品的分类
      listQuery: { // 搜索查询条件
        espage: 1,
        myprice: false,
        limit: 20,
        estotal: 0, // es产品总数
        essearch: {
          title: ''
        },
        goods_list_id: []
      },
      selectBrand: [], // 已选择的产品品牌
      selectName: [], // 已选择的产品属性
      brandList: [], // 品牌列表
      Attribute: [], // 属性列表
      listMode: 'card', // 产品展示样式，卡片或列表
      list: [], // 产品列表
      brandType: false,
      EsIdList: [], // 搜索协议属性时返回的产品ID集合，只在协议选中状态下属性筛选时使用
      cateType: false,
      fields: [],
      emptyShow: false,
      lookingSearch: [],
      ops_request_misc: '', // 数据上报需要参数
      request_id: '', // 数据上报需要参数
      u: 2,
      AttrOpen: false,
      AttrStyle: {
        marginTop: '10px',
        borderBottom: 'none'
      }
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  watch: {
    $route () {
      this.reload()
    }
  },
  mounted () {
    if (this.keywords) {
      this.listQuery.essearch.title = this.keywords
      this.getsearch()
      this.lookingsearch()
    }
  },
  methods: {
    // 查询协议产品
    screen () {
      this.listQuery.myprice = !this.listQuery.myprice
      var cate = []
      this.selectName.forEach((res) => {
        if (res.cate) {
          cate = res
        }
      })
      this.selectName = [] // 查询协议产品，清空已选的所有属性,分类除外
      this.selectName.push(cate)
      if (this.listQuery.myprice) {
        // 这是查询协议产品的sql条件
        this.listQuery.espage = 1
        this.listQuery.category_id = this.cid
        this.listQuery.goods_list_id = [] // 点击协议搜索时不需要转goods_list_id
        this.httpPriceList()
      } else {
        this.EsIdList = []
        this.checkCate()
      }
    },
    getsearch () {
      search.getsearch({listQuery: this.listQuery, fields: this.fields}).then(res => {
        this.searchCate = res.items // ES搜索结果包含关键词产品的分类
        this.estitleList = res.estitlelist
        this.listQuery.estotal = res.estotal
        if (res.esgoodsID.length > 0) {
          this.request_id = res.request_id
          this.ops_request_misc = res.ops_request_misc
          this.listQuery.goods_list_id = res.esgoodsID
          this.otherLoadData()
        } else {
          this.list = []
          this.emptyShow = true
        }
      })
    },
    // 分类点击筛选
    checkCate (index) {
      // 这里判断是点击分类还是取消协议，取消协议没有index所以也不需要给cid和selectName重新赋值
      if (index || index === 0) {
        this.cid = this.searchCate[index].id
        var cateList = {
          param_name: '分类',
          name: this.searchCate[index].title,
          id: this.searchCate[index].id,
          cate: 'cate' // 用于判断当前取消的是不是分类
        }
        this.selectName.push(cateList)
      }
      this.searchCateType = false
      this.listQuery.essearch.category_id = this.cid
      this.listQuery.espage = 1
      // this.getAttribute()

      search.attrEsSearch({category_id: this.searchCate[index].id, title: this.keywords}).then(res => {
        let list = res.items
        let brandList = res.brandList
        list.forEach(ele => { ele.showMore = false; ele.open = false; ele.isSelect = false })
        brandList.forEach(ele => { ele.showMore = false; ele.open = false; ele.isSelect = false; ele.param_name = '品牌' })
        this.Attribute = list
        this.brandList = brandList
        this.atterloading = false
      })
      this.getsearch()
    },
    // 取消选择的属性
    handleClose (index) {
      this.Attribute.forEach((res, i) => {
        if (res.id === this.selectName[index].param_id) {
          this.$set(this.Attribute[i], 'isSelect', false)
        }
      })
      // 判断当前取消的是不是品牌
      if (this.selectName[index].code) {
        this.brandType = false
        this.selectBrand = []
      }
      this.fields = []
      // 判断当前取消的是不是分类
      if (this.selectName[index].cate) {
        // 取消分类选项重新请求es，重置所有，只进行单个关键词es查询
        this.searchCateType = true
        this.selectName = []
        this.selectBrand = []
        this.$delete(this.listQuery.essearch, 'category_id') // 取消分类只进行单个关键词es查询条件中不能有category_id，所以这里删除对象中的category_id，为空会报错
        this.listQuery.espage = 1
        this.listQuery.goods_list_id = []
        this.listQuery.myprice = false
        this.Attribute = []
        this.brandList = []
        this.cid = ''
        this.getsearch()
      } else {
        // 因为取消分类选项不需要请求属性。所以放到else里
        this.selectName.splice(index, 1)
        this.attrFiltrate()
      }
    },
    // 获取分类下的产品属性
    getAttribute () {
      this.atterloading = true
      cate.getAttribute({cid: this.cid}).then(res => {
        let list = res.items
        let brandList = res.brandList
        list.forEach(ele => { ele.showMore = false; ele.open = false; ele.isSelect = false })
        brandList.forEach(ele => { ele.showMore = false; ele.open = false; ele.isSelect = false; ele.param_name = '品牌' })
        this.Attribute = list
        this.brandList = brandList
        this.atterloading = false
        // 判断属性修改样式
        if (this.Attribute.length > 4) {
          this.AttrStyle = {
            marginTop: '10px',
            borderBottom: 'none'
          }
        } else {
          this.AttrStyle = {
            marginTop: '10px'
          }
        }
      })
    },
    // 属性筛选事件
    checkAttribute (i, index) {
      if (this.selectName.indexOf(this.Attribute[index]['option_values'][i]) === -1) {
        this.$set(this.Attribute[index], 'isSelect', true)
        this.selectName.push(this.Attribute[index]['option_values'][i])
      }
      this.attrFiltrate()
    },
    attrFiltrate () {
      var newSelectName = []
      this.selectName.forEach((res) => {
        // 这里的code是从服务端返回的，判断当前点击是否是品牌，是的话不加入newSelectName这个对象中
        if (!res.code && !res.cate) {
          newSelectName.push(res)
        }
        // 判断当前点击是否是分类，是的话不加入newSelectName这个对象中
        // if (!res.cate) {
        //   newSelectName.push(res)
        // }
      })
      this.atterloading = true
      search.esAttrFiltrate({
        attrrButeList: JSON.stringify(newSelectName),
        category_id: this.cid,
        brand: JSON.stringify(this.selectBrand),
        keywords: this.keywords,
        EsIdList: this.EsIdList // 搜索协议属性时返回的产品ID集合，只在协议选中状态下属性筛选时使用
      }).then(response => {
        let list = response.items
        let brandList = response.brand_list
        list.forEach(ele => {
          ele.showMore = false; ele.open = false; ele.isSelect = false
          this.selectName.forEach(res => {
            if (ele.id === res.param_id) {
              ele.isSelect = true
            }
          })
        })
        this.fields = response.goods_id
        brandList.forEach(ele => { ele.showMore = false; ele.open = false; ele.isSelect = false; ele.param_name = '品牌' })
        this.Attribute = list
        // 判断属性修改样式
        if (this.Attribute.length > 4) {
          this.AttrStyle = {
            marginTop: '10px',
            borderBottom: 'none'
          }
        } else {
          this.AttrStyle = {
            marginTop: '10px'
          }
        }
        this.brandList = brandList
        this.atterloading = false
        this.listQuery.espage = 1
        search.getsearch({searchType: this.searchType, listQuery: this.listQuery, fields: response.goods_id, search: this.esCondition}).then(res => {
          this.searchCate = res.items
          this.estitleList = res.estitlelist
          this.listQuery.estotal = res.estotal
          if (res.esgoodsID.length > 0) {
            this.listQuery.goods_list_id = res.esgoodsID
            this.otherLoadData()
          } else {
            this.list = []
          }
        })
      })
    },
    changeOpen (index) {
      this.$set(this.Attribute[index], 'open', !this.Attribute[index].open)
    },
    getHeight (name, index) {
      this.$nextTick(() => {
        if (this.$refs[name][0]['offsetHeight'] > 34) {
          this.Attribute[index].showMore = true
        }
      })
    },
    otherLoadData () {
      if (this.qyloading) {
        return false
      }
      this.qyloading = true // 页面区域loading
      this.api.Query(this.listQuery).then(response => {
        if (this.afterLoadData) {
          response.items = this.afterLoadData(response.items)
        }
        this.list = response.items
        this.qyloading = false
      })
    },
    afterLoadData (list) {
      list.forEach(res => {
        if (res.specParamList) { res.specParamList = JSON.parse(res.specParamList) }
        this.estitleList.forEach(es => {
          if (res.id === es.id) {
            res.estitle = es.title
          }
        })
      })
      return list
    },
    httpPriceList () {
      if (this.qyloading) {
        return false
      }
      this.listQuery.espage = 1
      this.qyloading = true // 页面区域loading
      this.api.httpPriceList(this.listQuery).then(response => {
        this.list = response.items
        this.qyloading = false
        let attrlist = response.Attribute
        let brandList = response.brandList
        attrlist.forEach(ele => { ele.showMore = false; ele.open = false; ele.isSelect = false })
        brandList.forEach(ele => { ele.showMore = false; ele.open = false; ele.isSelect = false; ele.param_name = '品牌' })
        this.Attribute = attrlist
        this.brandList = brandList
        this.listQuery.estotal = response.total
        this.EsIdList = response.esIdList // 搜索协议属性时返回的产品ID集合，只在协议选中状态下属性筛选与ES搜索时使用
        search.getsearch({listQuery: this.listQuery, fields: response.esIdList, search: this.esCondition}).then(res => {
          this.searchCate = res.items
          this.estitleList = res.estitlelist
          this.listQuery.estotal = res.estotal
          if (res.esgoodsID.length > 0) {
            this.listQuery.goods_list_id = res.esgoodsID
            this.otherLoadData()
          } else {
            this.list = []
          }
        })
      })
    },
    checkBrand (index) {
      this.brandType = true
      this.selectBrand = this.brandList[index] // 此处赋值只为点击品牌传值，减少后台处理
      this.selectName.push(this.brandList[index])
      this.attrFiltrate()
    },
    changeCate () {
      this.cateType = !this.cateType
    },
    addCart (item) {
      if (!this.current_user.id) {
        this.$message.error('请先登录')
        return false
      }
      api.addCart({
        'id': item.id,
        'leaveMessage': item.leaveMessage
      }).then(() => {
        this.$notify({
          title: '加入购物车',
          message: '添加成功',
          type: 'success'
        })
      })
    },
    batchAddCart () {
      if (!this.current_user.id) {
        this.$message.error('请先登录')
        return false
      }
      var subCartList = []
      this.list.map((res) => {
        if (res.number) {
          var cartList = {
            goods_id: res.id,
            number: res.number,
            leaveMessage: res.leaveMessage
          }
          // if (this.subCartList.findIndex((item) => { return item.goods_id === res.id }) === -1) {
          subCartList.push(cartList)
          // }
        // } else {
        //   this.subCartList.splice(index, 1)
        }
      })

      if (subCartList.length > 0) {
        api.batchAddCart(subCartList).then(() => {
          this.$message({
            message: '添加成功',
            type: 'success'
          })
        })
      }
    },
    searchKwywords (title) {
      this.$router.push({name: 'Search', query: {keywords: title, searchType: 1}})
    },
    lookingsearch () {
      service.SearchSelect({ 'search': this.keywords }).then(res => {
        this.lookingSearch = res.items.suggestions
      })
    },
    // 跳转到详情并上报点击事件
    toSearchDetail (goodsID) {
      if (this.request_id) {
        api.toSearchDetail({'goodsID': goodsID, 'request_id': this.request_id, 'ops_request_misc': this.ops_request_misc}).then(res => {
          console.info(res)
        })
      }
      window.open('https://www.nmzp.com/#/GoodsDetail?id=' + goodsID, '_blank')
    },
    changeAttrOpen () {
      if (this.AttrOpen) {
        this.u = 2
        this.AttrOpen = false
      } else {
        this.u = this.Attribute.length
        this.AttrOpen = true
      }
    },
    // 收藏
    collect (item) {
      if (!this.current_user || !this.current_user.id) {
        this.$message.error('请先登录')
        return
      }
      api.delOrAddCollect({'member_id': this.current_user.id, 'goods_id': item.id}).then(res => {
        item.isCollect = item.isCollect === 1 ? 0 : 1
      })
    }
  }
}
</script>
<style scoped>
  .cght_cnxhtiwtjsp{ height:167px; width:100%; padding-top:175px;}
  .cght_cnxhtiwtjsp div{ width:144px; text-align:center; padding-left:100px; background:url(../../assets/images/spsc_img02.png) no-repeat left center; height:60px; line-height:60px;font-size:18px; color:#959595; margin:0px auto; clear:both;}
  .myemptydata {color:#959595}
  .agreement{
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 12;
    width: 60px;
  }
  .agreement_list{
    background-image:url('../../assets/images/xy22.png');
    background-repeat: no-repeat;
    background-position: right top;
    background-size: 70px 70px;
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .this_page_title{
    padding: 0 7px 0 7px;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
  }
  .hxq_ppsp_ul_jg {
    padding: 0 7px 0 7px;
  }
  .hxq_ppsp_ul_join{
    padding: 0 7px 0 7px;
  }
  .this_page_css {
    border-radius:5px ;
    margin: 15px 15px 0 0;
    padding: 10px 3px 10px 3px;
    -webkit-transition: all 0.25s ease-out;
    -o-transition: all 0.25s ease-out;
    transition: all 0.25s ease-out;
    border:1px solid #eaeaea;
  }
  .this_page_css:hover {
    box-shadow: 0 0 5px #cbdaf5;
    -webkit-box-shadow: 0 0 5px #cbdaf5;
    -moz-box-shadow: 0 0 5px #cbdaf5;
    transform: translate(0, -10px);
  }
  .this_page_li {
    margin: 15px 0;
    -webkit-transition: all 0.25s ease-out;
    -o-transition: all 0.25s ease-out;
    transition: all 0.25s ease-out;
  }
  .this_page_li:hover {
    box-shadow: 0 0 5px #cbdaf5;
    -webkit-box-shadow: 0 0 5px #cbdaf5;
    -moz-box-shadow: 0 0 5px #cbdaf5;
    transform: translate(0, -10px);
  }
  .fllbsmall_con_bottom_1l img {
    border: none;
  }
  .fllbsmall_con_bottom li{
    border: none;
    padding: 5px 0;
  }
  .myborder{
    height: 34px;
    line-height: 34px;
    border-bottom: none !important;
  }
  .selectTrue{
    float: left;
    padding: 6px;
    border: 1px solid #cccccc;
    border-radius: 3px;
    margin-left: 18px;
    margin-bottom:12px;
  }
  .delSelect{
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    color:#fff;
    line-height: 20px;
    text-align: center;
    font-weight: bold;
    background: #4b8df9;
  }
  .hxq_fllb_ysz_yj{
    transition: all .5s ease;
    overflow: hidden;
    box-sizing: border-box;
  }
  .hxq_fllb_ysz .hxq_fllb_ysz_yj{
    padding: 0;
    border: none;
  }
  .el-radio{
    margin-left: 5px !important;
    margin-right: 5px !important;
  }
  .showMoreAttr {
    background: #fff none repeat scroll 0 0;
    border-top: 1px solid #ddd;
    color: #999;
    cursor: pointer;
    font-size: 12px;
    height: 30px;
    line-height: 20px;
    position: relative;
    text-align: center;
    z-index: 1;
  }
  .showMoreAttr:hover{
    border-top: 1px solid #333;
    color: #333;
  }
  .showMoreAttr:hover .showmore-text{
    border-bottom: 1px solid #333;
    border-left: 1px solid #333;
    border-right: 1px solid #333;
  }
  .showMoreAttr:hover .showmore-text{
    border-bottom: 1px solid #333;
    border-left: 1px solid #333;
    border-right: 1px solid #333;
  }
  .showmore-text {
    background-color: #fff;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    display: block;
    height: 30px;
    line-height: 29px;
    margin-left: 450px;
    margin-top: -1px;
    position: absolute;
    width: 350px;
    z-index: 1;
  }
  .showmore-text:hover{
    border-bottom: 1px solid #333;
    border-left: 1px solid #333;
    border-right: 1px solid #333;
  }
  .showmore-text i.up-arrow {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
    background: url(../../assets/images/xjt.png) center 10% no-repeat;
  }
  .showmore-text i {
    width: 20px;
    height: 20px;
    background: url(../../assets/images/xjt.png) center 85% no-repeat;
    cursor: pointer;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/view/search/search.vue